adminApp.directive("localClientVersions", function(){
    return {
        templateUrl: '/public/directives/localClientVersions.html',
        scope: {
            elements: '=?',
            model: '='
        },
        controller:  ['$scope' , function($scope) {
            $scope.selected;
            $scope.onVersionClick = function (version) {
                var versionIndex = $scope.model.indexOf(version);

                if(versionIndex!= -1){
                    $scope.model.splice(versionIndex,1);
                }
                else{
                    $scope.model.push(version);
                }
            };

            $scope.$watch("elements", function(newVal, oldVal){
                if (newVal !== oldVal) {
                    $scope.clientsVersions = newVal;
                }
            });

        }]
    }
});
